import { render, staticRenderFns } from "./GrupoModal.vue?vue&type=template&id=7f22a5a4&scoped=true"
import script from "./GrupoModal.vue?vue&type=script&lang=js"
export * from "./GrupoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22a5a4",
  null
  
)

export default component.exports